import React, { useState, useEffect, FC, ChangeEvent } from 'react';

interface SpeedExceedAlarmProps {
  alarm: any;
  onChange: (newMetrics: any) => void;
}

const SpeedExceedAlarm: FC<SpeedExceedAlarmProps> = ({ alarm, onChange }) => {
  const [threshold, setThreshold] = useState<number>(alarm.threshold || 90);
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    if (alarm && alarm.speed_limit !== undefined) {
      setThreshold(alarm.speed_limit);
    } else {
      setThreshold(90); // valeur par défaut
    }
  }, [alarm]);

  const handleThresholdChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    // Vérifie que c'est un nombre entier positif
    if (/^\d+$/.test(value) && parseInt(value, 10) >= 0) {
      setThreshold(parseInt(value, 10));
      setErrorMessage('');
      onChange({ type: 'SpeedExceedAlarm', speed_limit: value });
    } else {
      setThreshold(parseInt(value, 10));
      setErrorMessage('Please enter a valid number.');
    }
  };

  return (
    <div className="form-group">
      <div style={{ position: 'relative', display: 'inline-block', width: '200px' }}>
        <input
          type="number"
          id="speedLimit"
          value={threshold}
          onChange={handleThresholdChange}
          className="form-control"
          min="0"
          step="1"
          pattern="\d*"
          style={{
            width: '100%',
            paddingRight: '50px',
            boxSizing: 'border-box'
          }}
        />
        <span
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#333'
          }}
        >
          Km/h
        </span>
      </div>

      {errorMessage && (
        <div
          className="error-message"
          style={{
            backgroundColor: '#ff4d4f',
            color: 'white',
            marginTop: '5px',
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '0.85em'
          }}
        >
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default SpeedExceedAlarm;
